$(document).ready(function() {
    //the product variant isn't always added to the iWish add button on page load, so it's retrieved from the product form and added to it (only runs when iWishAdd button exists)
    let iWishAdd = document.querySelector('a.iWishAdd');

    if (iWishAdd) {
      let variant_id = document.querySelector('.product__info-wrapper product-form input[name="id"]').value;
      setTimeout(function() {
        iWishAdd.setAttribute('data-variant', variant_id);
      }, 500);
    }

    //shows iwish count in header when it isn't empty
    setTimeout(function() {
      if ($('#iwish-counter').text() != '0') {
        $('#iwish-bubble').removeClass('visually-hidden');
      }
    }, 500);

    //closes wishlist drawer when cart drawer is opened
    $('body').on('click', '.cart-icon-bubble', function(event) {
      $('#mst-iwish-drawer-root .wish-title').click();
    });

    //wishlist drawer layout can't be edited, so when wishlist drawer is first opened, a custom share footer is moved from the header to the bottom of the wishlist drawer, then unhidden
    $('body').on('click', '.iwish-float-icon', function(event) {
      $('#iWish-share').appendTo('#iwish-drawer-root .iwish-drawer-menu');
      $('#iWish-share').removeClass('hidden');
    });

    //copies wishlist share URL to clipboard when copy icon is clicked
    $('body').on('click', '#iWish-share-copy', function(event) {
      let $customerID = sessionStorage.getItem('customerID');
      let $shopURL = sessionStorage.getItem('shopURL');
      var shareAddress = $shopURL + '/apps/iwish?share=' + $customerID;
      var tempTextarea = $('<textarea>');
      $('body').append(tempTextarea); //for some stupid reason it won't work on Safari or Chrome unless an additional textarea is created to add the URL to and copy from
      tempTextarea.val(shareAddress).select();
      document.execCommand('copy');
      tempTextarea.remove();
      alert('Wishlist URL has been copied to clipboard.');
    });

    /*
    //toggles expanded class to show/hide wishlist header icons
    //toggles overflow-hidden class on html to prevent scroll while wishlist drawer is open
    $('body').on('click', '.mst-drawer-title-icon, .iwish-float-icon, #iwish-drawer-root > div:not(.wishlist-drawer-container)', function(event) {
        console.log("clicked");
      $('.header__wishlist').toggleClass('expanded');
      if ($('.header__wishlist').hasClass('expanded')) {
        $('.header__wishlist .header__icon').each(function() {
            $(this).attr('aria-expanded', true);
        });
      } else {
        $('.header__wishlist .header__icon').each(function() {
            $(this).attr('aria-expanded', false);
        });
      }
      $('html').toggleClass('overflow-hidden');
    });
    */

    //.iwish-drawer-close is an icon shown in place of the heart when the wishlist is open on mobile
    //when clicked, it emulates a click on .mst-drawer-title-icon to close drawer
    $('body').on('click', '.iwish-drawer-close', function(event) {
      $('#iwish-drawer-root .mst-drawer-title-icon').click();
    });

    //by default the wishlist drawer says "preorder" on products which allow selling when out of stock and there's no option to change the button text
    //the drawer reloads every time it's opened and I can't find a way to bind a function to the reload, so the button text is changed after a timeout whenever a button is pressed which opens the drawer
    $('body').on('click', '.iwish-float-icon, a.iWishAdd, #iwish-drawer-root .paginationContainer .pagination .page-link, #iwish-drawer-root .dropdown-item', function(event) {
      setTimeout(function() {
        $('#iwish-drawer-root .add_to_cart span').text('Add To Cart');
      }, 1500);
    });

    //reloads the inner cart drawer div when something is added from wishlist
    //function bound to body as .cart-btn doesn't exist on page load
    $('body').on('click', '.iwish-drawer-menu .add_to_cart', function(event) {
      //uses a timeout to make sure product is added before refreshing cart
      setTimeout(function() {
        $('#CartDrawer').load(location.href + " #CartDrawer__inner");
        $('.cart-count-bubble').removeClass('visually-hidden');
        $('#CartDrawer__wrapper').removeClass('is-empty');
      }, 1000);
    });
  });